<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сторонние доставки</strong>
                </CCardHeader>
                <CCardBody>
                    <CCard class="p-1">
                        <CRow>
                            <CSwitch color="dark" shape="pill" variant="opposite" :checked.sync="showFilters" class="ml-4" />
                            <span class="ml-2">Экспорт</span>
                        </CRow>
                        <CRow v-if="showFilters" class="mb-1">
                            <CCol cols="12" md="2"> Дата начала: </CCol>
                            <CCol cols="12" md="4">
                                <DatePicker v-model="datepicker.dateFrom" :language="datepicker.lang" :format="datepicker.format" input-class="custom-datepicker" placeholder="Выберите дату..." />
                            </CCol>
                            <CCol cols="12" md="2"> Дата окончания: </CCol>
                            <CCol cols="12" md="4">
                                <DatePicker v-model="datepicker.dateTo" :language="datepicker.lang" :format="datepicker.format" input-class="custom-datepicker" placeholder="Выберите дату..." />
                            </CCol>
                        </CRow>
                        <CRow v-if="showFilters" class="mt-2">
                            <CCol md="4">
                                <CButton color="primary" @click="doExport">Запустить экспорт</CButton>
                            </CCol>
                            <CCol cols="3">
                                {{ exportMessage }}
                                <CLink to="/export">{{ exportFile }}</CLink>
                            </CCol>
                        </CRow>
                    </CCard>

                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary" />
                    </div>
                    <template v-else>
                        <OtherDeliveryTable class="mt-4" :list.sync="data" @select="(id) => $router.push(`other-delivery/${id}`)" />

                        <CPagination v-if="total > 1" class="mt-4" :active-page.sync="activePage" :pages="total" align="center" />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" class="mr-3" @click="$router.push(`other-delivery/create`)">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import OtherDeliveryTable from '@/components/other-delivery/OtherDeliveryTable';
import { ITEMS_PER_PAGE } from '@/utils/views';
import DatePicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import Vue from 'vue';

export default {
    name: 'OtherDeliveryList',

    components: {
        OtherDeliveryTable,
        DatePicker,
    },

    data() {
        return {
            loading: true,
            data: [],
            total: 0,
            itemsPerPage: ITEMS_PER_PAGE,
            showFilters: false,
            datepicker: {
                lang: ru,
                format: 'dd.MM.yyyy',
                dateFrom: null,
                dateTo: null,
            },
            exportCanceled: false,
            totalOrders: null,
            exportMessage: '',
            exportFile: '',
        };
    },

    computed: {
        activePage: {
            get() {
                return parseInt(this.$route.query.page) || 1;
            },
            async set(v) {
                const query = { page: v };
                this.$router.push({ query });
            },
        },
    },

    watch: {
        activePage: 'fetchList',
    },

    async created() {
        await Promise.all([this.fetchList()]);
        this.loading = false;
    },

    methods: {
        async fetchList() {
            const params = {
                page: this.activePage,
                pageSize: this.itemsPerPage,
            };
            const response = await this.axios.get('/other-deliveries', { params });
            this.data = response.data.results;
            this.total = Math.ceil(response.data.total / this.itemsPerPage);
        },
        doExport() {
            if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                return;
            }
            const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
            const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');

            Vue.axios
                .get(
                    `/export/other-deliveries?dateFrom=${dateFrom}&dateTo=${dateTo}`,
                    { responseType: 'blob' }
                )
                .then(response => {
                    const bom = decodeURIComponent('%ef%bb%bf')
                    const fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'text/csv;charset=utf-8' }));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        'download',
                        'Export-' + dateFrom + '-' + dateTo + '.csv'
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
        },
    },
};
</script>

<style>
input.custom-datepicker {
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
</style>